import { Textarea, TextInput } from "@mantine/core";
import type { ReactElement } from "react";
import type { TFunction } from "i18next";

// Форма apply `checklist_tweak` для ProposalCard. Зеркало
// `config_update` (configUpdate.tsx). Человек подтверждает репозиторий (`owner/repo`)
// и текст пункта — предложение LLM = рекомендация в `proposal_text`, не
// источник истины (см. спека 03-agents/roles/overrides § «Применение checklist_tweak»).

// Чистая проверка готовности формы checklist_tweak к apply. Оба поля
// обязаны быть непустыми после trim'а (backend отвергает blank 422).
// Вынесена чистой функцией: TextInput/Textarea onChange в jsdom зовётся, но
// держим логику отдельно от компонента для прямого юнита (как у
// validateConfigValue). Зеркалит `_not_blank`-валидатор backend-схемы.
export function isChecklistTweakReady(
  repoFullName: string,
  checklistText: string,
): boolean {
  return repoFullName.trim().length > 0 && checklistText.trim().length > 0;
}

// Форма checklist_tweak: поле репозитория `owner/repo` + textarea текста
// пункта. Значения подтверждает человек; ProposalCard собирает из них тело
// apply (`buildApplyArgs`) после проверки `isChecklistTweakReady`.
export function ChecklistTweakForm({
  repoFullName,
  setRepoFullName,
  checklistText,
  setChecklistText,
  busy,
  t,
}: {
  readonly repoFullName: string;
  readonly setRepoFullName: (value: string) => void;
  readonly checklistText: string;
  readonly setChecklistText: (value: string) => void;
  readonly busy: boolean;
  readonly t: TFunction;
}): ReactElement {
  return (
    <>
      <TextInput
        label={t("selfImprovement.checklistRepoLabel")}
        description={t("selfImprovement.checklistRepoHint")}
        placeholder={t("selfImprovement.checklistRepoPlaceholder")}
        value={repoFullName}
        onChange={(event) => {
          setRepoFullName(event.currentTarget.value);
        }}
        disabled={busy}
      />
      <Textarea
        label={t("selfImprovement.checklistTextLabel")}
        description={t("selfImprovement.checklistTextHint")}
        placeholder={t("selfImprovement.checklistTextPlaceholder")}
        value={checklistText}
        onChange={(event) => {
          setChecklistText(event.currentTarget.value);
        }}
        disabled={busy}
        rows={2}
      />
    </>
  );
}
